/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './trimester-observation-param.reducer';

export const TrimesterObservationParamDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const trimesterObservationParamEntity = useAppSelector(state => state.trimesterObservationParam.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="trimesterObservationParamDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.detail.title">TrimesterObservationParam</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.id">Id</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.id}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.observation}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.comments}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.active">Active</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{trimesterObservationParamEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.trimester">Trimester</Translate>
          </dt>
          <dd>{trimesterObservationParamEntity.trimester ? trimesterObservationParamEntity.trimester.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.vital">Vital</Translate>
          </dt>
          <dd>{trimesterObservationParamEntity.vital ? trimesterObservationParamEntity.vital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/trimester-observation-param" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/trimester-observation-param/${trimesterObservationParamEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TrimesterObservationParamDetail;
